// Height and weight are always stored in metric (whole cm, kg to 0.1).
// Imperial values are only a display. To keep metric -> imperial -> metric
// stable, the stored metric value is kept unless the imperial input was edited.

export const CM_PER_INCH = 2.54
export const IN_PER_FT = 12
export const KG_PER_LB = 0.45359237

export const toNum = (v) => {
  if (v === null || v === undefined) return null
  const s = typeof v === 'string' ? v.trim() : v
  if (s === '') return null
  const x = Number(s)
  return Number.isFinite(x) ? x : null
}

export const roundKg = (kg) => Math.round(kg * 10) / 10

export const cmToFtIn = (cm) => {
  const totalIn = Math.round(cm / CM_PER_INCH)
  return { ft: Math.floor(totalIn / IN_PER_FT), inch: totalIn % IN_PER_FT }
}

export const ftInToCm = (ft, inch) => Math.round(((ft || 0) * IN_PER_FT + (inch || 0)) * CM_PER_INCH)

export const kgToLb = (kg) => Math.round(kg / KG_PER_LB)

export const lbToKg = (lb) => roundKg(lb * KG_PER_LB)

// Height in cm for the given ft/in inputs; keeps originalCm when the inputs still show it
export const resolveHeightCm = (originalCm, ftInput, inchInput) => {
  const ft = toNum(ftInput)
  const inch = toNum(inchInput)
  if (ft === null && inch === null) return null
  const orig = toNum(originalCm)
  if (orig !== null) {
    const shown = cmToFtIn(orig)
    if (ftInToCm(ft, inch) === ftInToCm(shown.ft, shown.inch)) return orig
  }
  return ftInToCm(ft, inch)
}

// Weight in kg for the given lb input; keeps originalKg when the input still shows it
export const resolveWeightKg = (originalKg, lbInput) => {
  const lb = toNum(lbInput)
  if (lb === null) return null
  const orig = toNum(originalKg)
  if (orig !== null && kgToLb(orig) === lb) return orig
  return lbToKg(lb)
}

// Same idea for the metric inputs: older records can hold more precision than the
// inputs show (e.g. 83.91469 kg), so keep the stored value unless the input was edited
export const resolveMetricHeightCm = (originalCm, cmInput) => {
  const cm = toNum(cmInput)
  if (cm === null) return null
  const orig = toNum(originalCm)
  if (orig !== null && Math.round(orig) === Math.round(cm)) return orig
  return Math.round(cm)
}

export const resolveMetricWeightKg = (originalKg, kgInput) => {
  const kg = toNum(kgInput)
  if (kg === null) return null
  const orig = toNum(originalKg)
  if (orig !== null && roundKg(orig) === roundKg(kg)) return orig
  return roundKg(kg)
}

// Display values for the given stored metric values ('' when not set)
export const heightDisplay = (cm, imperial) => {
  const v = toNum(cm)
  if (v === null || v <= 0) return imperial ? { ft: '', inch: '' } : ''
  return imperial ? cmToFtIn(v) : Math.round(v)
}

export const weightDisplay = (kg, imperial) => {
  const v = toNum(kg)
  if (v === null || v <= 0) return ''
  return imperial ? kgToLb(v) : roundKg(v)
}
